// src/graphql/queries/SELLER_RMA_LIST.ts
import { gql } from '@apollo/client';

export const SELLER_RMA_LIST = gql`
  query SellerRMAList($page: Int, $page_size: Int, $filter: RMAFilterInput) {
    sellerRMAList(page: $page, page_size: $page_size, filter: $filter) {
      items {
        id
        resolution_type
        refunded_amount
        creation_date
        customer_name

        order_ref
        order_id
        status
        {
          code
        }
      }
      page_info {
        page_size
        current_page
        total_pages
      }
      total_count
      rma_status_count
    {
        code
        count
    }
    }

  }
`;
